export class ResponseDataValidatorError extends Error {
  type: string
  constructor(error: Error) {
    super(error.message)
    this.type = 'response-data-validator-error'
    this.name = error.name
  }
}
